import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row g-5 g-xl-8 mb-5" }
const _hoisted_2 = { class: "col-xl-12" }
const _hoisted_3 = { class: "row g-5 g-xl-8" }
const _hoisted_4 = {
  key: 0,
  class: "col-xl-4 align-self-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductGCBalances = _resolveComponent("ProductGCBalances")
  const _component_ECWalletReload = _resolveComponent("ECWalletReload")
  const _component_ECWalletHistory = _resolveComponent("ECWalletHistory")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_ProductGCBalances, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      (!_ctx.isOverriden)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_ECWalletReload, { "widget-classes": "mb-5 mb-xxl-8" })
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: _ctx.isOverriden ? 'col-xl-12' : 'col-xl-8'
      }, [
        _createVNode(_component_ECWalletHistory, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
      ], 2)
    ])
  ], 64))
}